import React from 'react';
import moment from 'moment';
import { get } from 'lodash';

import styles from './chartTooltipIdeaStyles';

import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import Link from 'buyside/components/presentation/Link/link';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';

import UpArrowIcon from 'buyside/svgs/up_arrow.svg';
import DownArrowIcon from 'buyside/svgs/down_arrow.svg';

import { defaultUserImageUrl, ideaUrl, userUrl } from 'buyside/util/urlHelper';
import separateWithDots from 'buyside/util/separateWithDots';

const ChartTooltipIdea = ({ idea, currency, showUserDetails }) => {
  const { id, positions, elevatorPitch, createdAt, totalReturn, returnTarget, user } = idea;
  const { priceTarget } = positions[0];
  const date = moment(createdAt);
  const daysAgo = moment().diff(date, 'days');

  return (
    <div className={styles.ideaTooltip}>
      <div className={styles.ideaTooltipHeader}>
        <strong>{separateWithDots(positions.map(position => position.asset.primarySymbol))}</strong>{' '}
        Idea posted on {date.format('M/D/YY')}
      </div>
      <div className={styles.contentArea}>
        <ProfileImage
          source={showUserDetails ? user.profileImageUrl : defaultUserImageUrl()}
          size="tiny"
          style={styles.profileImage}
        />
        <section>
          <div className={styles.displayName}>
            {showUserDetails ? (
              <Link to={userUrl(user.id)}>{user.displayName}</Link>
            ) : (
              <AnonymousUserDisplay
                anonUser={{ title: get(user, 'mostRecentEmployer.title', '') }}
              />
            )}
          </div>
          <div className={styles.postedDate}>
            <span>
              Posted {daysAgo} day{daysAgo === 1 ? '' : 's'} ago
            </span>
            |
            <ReturnValue value={totalReturn} />
          </div>
          <div className={styles.targetPrice}>
            {priceTarget && (
              <span>
                Target Price: {priceTarget} {currency}
              </span>
            )}
            {returnTarget && <span>Target Return: {returnTarget}%</span>}
            {positions.map(position => {
              const { direction } = position;
              if (['Redacted', ''].includes(direction)) return null;
              const directionColor = direction === 'long' ? styles.green : styles.red;
              return (
                <div className={`${styles.directionText} ${directionColor}`} key={position.id}>
                  {direction === 'long' ? (
                    <>
                      | <UpArrowIcon className={styles.upArrowIcon} />
                    </>
                  ) : (
                    <>
                      | <DownArrowIcon className={styles.downArrowIcon} />
                    </>
                  )}
                  {direction}
                </div>
              );
            })}
          </div>
          {elevatorPitch && (
            <div className={styles.elevatorPitch}>
              {elevatorPitch
                .split(' ')
                .splice(0, 14)
                .join(' ')}
              ...
            </div>
          )}
          <div className={styles.ideaButton}>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              size={BUTTON_SIZES.TINY}
              url={ideaUrl(id)}
              text="View Idea"
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ChartTooltipIdea;
